import { ToggleButton } from "plos/src/components/ToggleButton";
import { ToggleButtonGroup } from "plos/src/components/ToggleButtonGroup";
import { useLocalizedNavigate } from "plos/src/hooks/useLocalizedNavigate";
import { localizePath } from "plos/src/utils/language";
import { Key, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useTrackingContext } from "../../../contexts/TrackingContext";
import { toggleButtonWrapper } from "./leaguesAndCupsToggle.css";

type LeaguesAndCupsView = "leagues" | "cups";

interface LeaguesAndCupsToggleProps {
  selected: LeaguesAndCupsView;
}

const LeaguesAndCupsToggle = ({ selected }: LeaguesAndCupsToggleProps) => {
  const { lang } = useParams();
  const { t } = useTranslation("leaguesAndCups");

  const { firePageViewEvent } = useTrackingContext();
  const navigate = useLocalizedNavigate();

  const linksDict = {
    leagues: localizePath("/leagues", lang),
    cups: localizePath("/leagues/cups", lang),
  };

  const handleViewChange = (keys: Set<Key>) => {
    const key = Array.from(keys)[0] as LeaguesAndCupsView;
    if (key) {
      navigate(linksDict[key]);
    }
  };

  useEffect(() => {
    firePageViewEvent(
      "fantasy leagues & cups",
      selected === "leagues" ? "league view" : "cup view",
    );
  }, []);

  return (
    <div className={toggleButtonWrapper}>
      <ToggleButtonGroup
        selectedKeys={new Set([selected])}
        onSelectionChange={handleViewChange}
      >
        <ToggleButton id="leagues">
          {t("leaguesAndCupsToggle.leagues", "Leagues")}
        </ToggleButton>
        <ToggleButton id="cups">
          {t("leaguesAndCupsToggle.cups", "Cups")}
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};

export default LeaguesAndCupsToggle;
